import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import LegendBar from 'components/Shared/LegendBar/Index'
import colors from 'components/utils/colors'

import { getFieldGroups, hasRequiredFields } from 'components/Shared/TableFormFieldsBuilder/utils'

const RequiredLegend = ({ fieldParams, isVisible, t, className }) => {
  let show = isVisible
  if (!isVisible && fieldParams) {
    const fieldGroups = getFieldGroups(fieldParams)
    show = hasRequiredFields(fieldGroups)
  }

  if (!show) {
    return null
  }

  const requiredBarItems = [
    { color: colors.alert, label: t('common.requiredField') },
  ]

  return (
    <LegendBar items={requiredBarItems} className={className} />
  )
}

RequiredLegend.propTypes = {
  fieldParams: PropTypes.array,
  isVisible: PropTypes.bool,
  t: PropTypes.func,
}

export default withTranslation()(RequiredLegend)
